import * as firebase from 'firebase/app'
import 'firebase/firestore'

// settings for database on christian.zellweger@derbund.ch
const firebaseConfig = {
  apiKey: 'AIzaSyDq9TrQs4dNX4taXo6tM60_zC86qKFcl60',
  authDomain: 'wahlchallenge.firebaseapp.com',
  databaseURL: 'https://wahlchallenge.firebaseio.com',
  projectId: 'wahlchallenge',
  storageBucket: 'wahlchallenge.appspot.com',
  messagingSenderId: '755872666105',
  appId: '1:755872666105:web:8c2fedf5d0192b19'
}

// settings for database on chzellweger@gmail.com
// const firebaseConfig = {
//   apiKey: 'AIzaSyBqA0SqHs6Q4rB4Lwef2QhWIWGKSgG6Ulc',
//   authDomain: 'wahlchallenge-test.firebaseapp.com',
//   databaseURL: 'https://wahlchallenge-test.firebaseio.com',
//   projectId: 'wahlchallenge-test',
//   storageBucket: 'wahlchallenge-test.appspot.com',
//   messagingSenderId: '590960777111'
// }

firebase.initializeApp(firebaseConfig)

const database = firebase.firestore()

export default database
